import { useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { fetchSupClasses } from "../api/supClass.api";

const useSupClasses = () => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken])
  );

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["supClasses"],
    queryFn: () => fetchSupClasses(bearerToken),
  });

  const fetchSupClassesData = async () => {
    await refetch();
  };

  return {
    supClasses: data,
    error,
    isLoading,
    fetchSupClassesData,
  };
};

export default useSupClasses;
